import React, { Component } from 'react';
import { post } from '../../util/api';
import _ from 'lodash';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import { FormControl, Paper, Input, Button, Box, TableContainer, TableBody, TableHead, Table, TableRow, TableCell } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ReplayIcon from '@mui/icons-material/Replay';

const DATE_FORMAT = 'DD.MM.YY HH:mm';

export default class Feedback extends Component {
	state = {
		loading: true,
		activePage: 1,
		limit: 10000,
		email: '',
		buttonloading: true,
		firstItem: 0,
		lastItem: 49,
		dataPage: 0,
		date: '2022-05-01T08:01:43.630Z',
		email_data: '',
	};
	componentDidMount() {
		this.postData();
	}
	/* componentDidUpdate(oldProps, oldState) {
        const check_list = ['activePage'];
        for (let i = 0; i < check_list.length; i++) {
            const key = check_list[i];
            if (this.state[key] !== oldState[key]) {
                this.postData();
                break;
            }
        }
    } */
	postData() {
		let { activePage, limit, email } = this.state;
		//console.log(activePage);
		let body = {
			page: parseInt(activePage) - 1,
			limit,
			filter: {},
		};
		if (email !== '') {
			body = {
				page: parseInt(activePage) - 1,
				limit,
				filter: {
					email,
				},
			};
		}
		//console.log('feedback geldi - 0');
		post('/maytapi/admin/feedback', body).then((temp) => {
			//console.log('feedback geldi - 6', temp);
			this.setState({
				loading: false,
				list: temp && temp.data && temp.data.footprints,
				general: temp.data.general,
				temp: temp.data,
				buttonloading: false,
			});
		});
	}
	handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

	handleSort(clickedColumn) {
		return () => {
			if (this.state.column !== clickedColumn) {
				this.setState({
					column: clickedColumn,
					list: _.sortBy(this.state.list, [clickedColumn]),
					direction: 'ascending',
				});

				return;
			}

			this.setState({
				column: clickedColumn,
				list: this.state.list.reverse(),
				direction: this.state.direction === 'ascending' ? 'descending' : 'ascending',
			});
		};
	}

	filterValue(val) {
		let { list, date } = this.state;
		let result = _.filter(list, function (o) {
			if (date) {
				return o.extra.feedback_id === val && o.date > date;
			} else {
				return o.extra.feedback_id === val;
			}
		});
		let emaildata = '';
		let emails = result && result.map((e) => e.email).filter((value, index, self) => self.indexOf(value) === index);
		_.each(emails, (a) => {
			emaildata += a + ',';
		});

		if (emails) this.setState({ email_data: emaildata });

		this.setState({ otherFilter: result, key: val });
	}

	filterValueReset() {
		this.setState({ otherFilter: '' });
	}

	handleChange = (e) => {
		let { firstItem, lastItem } = this.state;
		let { name, value } = e.target;
		if (name === 'activePage' && value < 1) {
			value = 1;
		}
		if (name === 'email') {
			value = value.trim();
		}
		if (name === 'activePage') {
			firstItem = 0 + (value - 1) * 50;
			lastItem = 49 + (value - 1) * 50;
		}
		this.setState({ [name]: value });
		this.setState({ firstItem, lastItem });
	};

	handleDateChange = (e) => {
		let { value } = e.target;
		this.setState({ date: value });
	};
	render() {
		const { list, loading, activePage, general, email, buttonloading, firstItem, lastItem, dataPage, otherFilter, date, email_data } = this.state;
		if (loading) return <Box attached="bottom">loading...</Box>;
		//console.log('activePage', activePage, firstItem, lastItem, list);
		let filterData = _.filter(list, function (it, i) {
			return i >= firstItem && i <= lastItem;
		});

		if (otherFilter) filterData = otherFilter;

		if (email) {
			filterData = _.filter(list, function (it) {
				var regex = new RegExp(email, 'g');
				return regex.test(it.email);
			});
		}
		if (email) {
			filterData = _.filter(filterData, function (it, i) {
				return i >= firstItem && i <= lastItem;
			});
		}
		return (
			<Paper elevation={24} className="mytp-dashboard" sx={{ padding: '15px' }}>
				<div
					css={`
						display: flex;
						> div {
							span {
								font-weight: bold;
								text-transform: capitalize;
							}
							margin-right: 5px;
							padding: 6px 12px;
							border: 1px solid #ccc;
							border-radius: 3px;
						}
					`}
				>
					{_.map(general, (value, key) => (
						<div
							style={{ cursor: 'pointer' }}
							onClick={() => {
								this.filterValue(key);
							}}
						>
							<span>{key.replace(/_/g, ' ')}</span>: {value}
						</div>
					))}
				</div>
				<div
					style={{ alignItems: 'center' }}
					css={`
						display: flex;
						> div {
							span {
								font-weight: bold;
								text-transform: capitalize;
							}
							margin-right: 5px;
							padding: 6px 12px;
							border: 1px solid #ccc;
							border-radius: 3px;
							margin: 15px 0;
						}
					`}
				>
					<FormControl variant="standard" style={{ marginRight: '15px' }}>
						<Input
							style={{ width: '200px' }}
							id="component-simple"
							value={date}
							name="date"
							defaultValue={'2022-05-01T08:01:43.630Z'}
							onChange={this.handleChange}
							placeholder="2022-06-07T08:01:43.630Z"
						/>
					</FormControl>
					{/* <Button
						type="button"
						icon
						style={{ height: '41px', marginRight: '15px' }}
						onClick={() => {
							this.setState({ date: '' });
						}}
					>
						{buttonloading ? <HourglassBottomIcon /> : <CloseIcon />}
					</Button> */}
					{otherFilter ? (
						<>
							<Button
								type="button"
								icon
								style={{ height: '41px', marginRight: '15px' }}
								onClick={() => {
									this.filterValue(this.state.key);
								}}
							>
								<ReplayIcon />
							</Button>

							<div
								style={{ background: 'red', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
								onClick={() => {
									this.filterValueReset();
								}}
							>
								Delete Filter
							</div>
							<div style={{ marginLeft: '15px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
								<CopyToClipboard text={email_data}>
									<span>Copy Emails</span>
								</CopyToClipboard>
							</div>
						</>
					) : null}
				</div>
				<div style={{ marginTop: '10px', display: 'flex' }}>
					<div style={{ display: 'flex' }}>
						{/* <Input placeholder="Email..." value={email} name="email" onChange={this.handleChange} /> */}
						<FormControl variant="standard">
							<Input id="component-simple" value={email} name="email" onChange={this.handleChange} placeholder="Email" />
						</FormControl>
						<Button icon style={{ marginLeft: '5px', height: '41px' }}>
							{buttonloading ? <HourglassBottomIcon /> : <SearchIcon />}
						</Button>
						<Button
							type="button"
							icon
							style={{ height: '41px' }}
							onClick={async () => {
								await this.setState({ email: '' });
							}}
						>
							{buttonloading ? <HourglassBottomIcon /> : <CloseIcon />}
						</Button>
					</div>
				</div>
				<TableContainer sx={{ marginTop: '15px' }}>
					<Table sortable celled>
						<TableHead>
							<TableRow>
								<TableCell textAlign="center" style={{ width: 70 }} collapsing>
									ID
								</TableCell>
								<TableCell>Email</TableCell>
								<TableCell>Subscription</TableCell>
								<TableCell>Unsubscribe Reason</TableCell>
								<TableCell>Answer</TableCell>
								<TableCell>Unsubscription Date</TableCell>
								<TableCell>Phone Number</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{_.map(filterData, (it, i) => {
								//console.log('it ', it);
								let { date, email, extra } = it;
								let { feedback_id, feedback_text,feedback_phone_number } = extra;
								//let emailDomain = email.match(/@(.*)/)[1];
								return (
									<TableRow key={i + 1}>
										<TableCell textAlign="center">
											<span>{i + 1}</span>
											{/* <CopyToClipboard text={copy_text}>
                                            <span>{i}</span>
                                        </CopyToClipboard> */}
										</TableCell>
										<TableCell>
											{/* {subscription ? (
                                            <a href={'/yta/logs?uid=' + uid} target="_blank" rel="noopener noreferrer">
                                                {email}
                                            </a>
                                        ) : ( */}
											{email}
											{/* )}
                                        {emailDomain ? (
                                            <a href={'https://' + emailDomain} target="_blank" rel="noopener noreferrer" style={{ marginLeft: '12px' }}>
                                                <Icon name="external alternate" />
                                            </a>
                                        ) : null} */}
										</TableCell>
										<TableCell>{extra.package}</TableCell>
										<TableCell>{feedback_id}</TableCell>
										<TableCell>{feedback_text}</TableCell>

										<TableCell>{date ? moment(date).format(DATE_FORMAT) : ''}</TableCell>
										<TableCell>{feedback_phone_number}</TableCell>
									
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Button
						icon
						labelPosition="left"
						loading={buttonloading}
						onClick={async () => {
							await this.setState({
								activePage: parseInt(activePage) - 1 < 1 ? 1 : parseInt(activePage) - 1,
								dataPage: dataPage - 1 < 0 ? 0 : dataPage - 1,
								//buttonloading: parseInt(activePage) - 1 < 1 ? false : true,
							});
							await this.setState({
								firstItem: 0 + dataPage * 50,
								lastItem: 49 + dataPage * 50,
							});
						}}
						disabled={buttonloading}
					>
						<ArrowBackIcon />
						Prev
					</Button>
					<div style={{ display: 'flex', width: '64px', marginRight: '4px' }}>
						<Input className="text-center" value={activePage} name="activePage" onChange={this.handleChange} style={{ textAlign: 'center' }} />
					</div>
					<Button
						icon
						labelPosition="right"
						loading={buttonloading}
						onClick={async () => {
							await this.setState({
								activePage: parseInt(activePage) + 1,
								//buttonloading: true,
							});
							await this.setState({
								firstItem: 0 + activePage * 50,
								lastItem: 49 + activePage * 50,
							});
							//await this.postData();
						}}
						disabled={buttonloading}
					>
						Next
						<ArrowForwardIcon size="small" />
					</Button>
				</div>
			</Paper>
		);
	}
}
